export const resultsColumns = {
    UPGRADES: () => {
        return [{ name: 'Cards', uid: 'name' }];
    },
    LEADERBOARD: () => {
        const isNarrow = window.innerWidth < 700;
        const scoreCol = isNarrow ? 80 : 140;
        const avatarCol = 65;
        const titleMin = isNarrow ? 120 : 200;
        const max = Math.max(titleMin, window.innerWidth - avatarCol - scoreCol - 50);

        let columns = [
            { name: 'user', uid: 'authorAvatarUrl', maxWidth: avatarCol, minWidth: avatarCol, width: avatarCol },
            { name: 'Title and Commander(s)', uid: 'commanders', maxWidth: max, minWidth: titleMin, width: max },
            { name: '', uid: 'saltRating', maxWidth: scoreCol, minWidth: scoreCol, width: scoreCol },
        ];

        return columns;
    },
    LEADERBOARD_COMPACT: () => {
        return [
            { name: 'user', uid: 'authorAvatarUrl', flex: '0 0 50px', width: 50, minWidth: 50, maxWidth: 50 },
            {
                name: 'Title and Commander(s)',
                uid: 'commanders',
                flex: '1 1 0',
                width: 0,
                minWidth: 0,
                overflow: 'hidden',
            },
            { name: '', uid: 'saltRating', flex: '0 0 80px', width: 80, minWidth: 80, maxWidth: 80 },
        ];
    },
};
